/**
 * `<PrepSplitPanelSkeleton>` — chrome-skeleton for the Interview Prep
 * tab `loading-existing` phase (Batch 30j-4).
 *
 * Composes `<Skeleton>` (foundations §9.19) ONLY. Mirrors the post-load
 * `<PrepSplitPanel>` layout positionally so the skeleton → loaded
 * transition is positionally stable.
 *
 * HARD-4 (HoD-30j4-4 / S-30j4-11): NO new shimmer code. NO new keyframes.
 * NO new primitives. The `<Skeleton>` primitive is the single source of
 * truth for shimmer styling.
 */
import type { JSX } from "react";

import { Skeleton } from "@/components/common/Skeleton";

export function PrepSplitPanelSkeleton(): JSX.Element {
  return (
    <div className="px-content-px py-5" data-testid="prep-skeleton">
      <div
        className="flex overflow-hidden rounded-xl border border-border-default bg-surface-card"
        style={{ height: "480px" }}
      >
        {/* Nav placeholder — six skeleton rows mirror the six fixed sections. */}
        <div className="flex w-[200px] flex-col gap-2 border-r border-border-default p-3">
          {Array.from({ length: 6 }).map((_, i) => (
            <Skeleton key={i} width="100%" height={28} rounded="md" />
          ))}
        </div>
        {/* Detail placeholder — short label header + 10 markdown body rows. */}
        <div className="flex-1 space-y-2 p-4">
          <Skeleton
            width={120}
            height={11}
            rounded="md"
            className="mb-3"
          />
          {Array.from({ length: 10 }).map((_, i) => (
            <Skeleton
              key={i}
              width={`${82 + ((i * 11) % 18)}%`}
              height={11}
              rounded="md"
            />
          ))}
        </div>
      </div>
    </div>
  );
}
